import { Box, Text, Button } from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { calculateDateRange } from "../../redux/actions/actions";
import { deleteCourse } from "../../redux/api_calls/apiCalls";
import IndividualCourseCard from "./IndividualCourseCard";

export default function AllCourses({ courses, method, loadMoreVisible }) {
    const dispatch = useDispatch()
    const deleteHandler = (id) => {
        let updatedCourses = courses.filter(course => course.id !== id)
        dispatch(deleteCourse(updatedCourses, id))
    }

    return (
        <Box width={['90%', '85%', '80%', '80%']} flexDirection='column' justifyContent='space-between' alignItems='center' d={['none', 'none', 'none','none', 'flex']} mb='1.5rem' >
            <Box d={['none', 'none', 'none','none', 'flex']} width='100%' p='1rem'>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='30%'>Course</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Enrolled Employees</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='20%' textAlign='center'>Certified Employees</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='10%' textAlign='center'>Topics</Text>
                <Text variant='custom' style={{ fontFamily: 'Mulish, sans-serif' }} width='15%' textAlign='center'>Actions</Text>
            </Box>
            {
                courses.map((course) => <IndividualCourseCard
                    key={course.id}
                    image={course.cover_image_url}
                    name={course.title}
                    dates={calculateDateRange(course.start_date, course.end_date)}
                    certifiedEmployee={course.certified_employees}
                    enrolledEmployee={course.enrolled_employees}
                    topics={course.topics_count}
                    id={course.id}
                    removeCourse={deleteHandler}
                />)
            }
            {
                loadMoreVisible &&
                <Button
                    color='#00000099'
                    style={{ fontFamily: 'Mulish, sans-serif' }}
                    fontWeight='700'
                    fontSize={['14px', '16px', '18px', '20px']}
                    border='2px solid rgba(0, 0, 0, 0.1)'
                    boxShadow='0px 3px 16px rgba(0, 0, 0, 0.1)'
                    borderRadius='xl'
                    py={['0.5rem', '0.75rem', '1rem', '1.5rem']}
                    px={['0.75rem', '1rem', '1.5rem', '2rem']}
                    m='2rem'
                    bg='#ffffff'
                    onClick = {method}
                >
                    Load More...
                </Button>
            }
        </Box>
    )
}